import { useState } from "react";
import { uploadTempImage } from "../../utils/uploadImage";

const subsections = [
  {
    id: "social-networks",
    options: ["Tik tok", "Instagram", "Facebook", "Otra"],
    type: "checkbox",
  },
];

const Step3Form = ({ data, onChange }) => {
  const [previews, setPreviews] = useState(
    (data.images || []).map((url) => ({
      id: Date.now() + Math.random(),
      remoteUrl: url,
    }))
  );
  const [uploading, setUploading] = useState(false);

  const handleCheckboxChange = (sectionId, option, checked) => {
    onChange(sectionId, {
      ...data[sectionId],
      [option]: checked,
    });
  };

  const handleInputChange = (e) => {
    onChange("url", e.target.value);
  };

  const updateFormImages = (list) => {
    const urls = list.map((p) => p.remoteUrl).filter(Boolean);
    onChange("images", urls);
  };

  const handleFileChange = async (e) => {
    const files = Array.from(e.target.files).slice(0, 4 - previews.length);
    if (files.length === 0) return;

    setUploading(true);

    try {
      const uploadPromises = files.map((file) =>
        uploadTempImage(file).then((url) => ({
          id: Date.now() + Math.random(),
          remoteUrl: url,
        }))
      );

      const uploaded = await Promise.all(uploadPromises);

      const newPreviews = [...previews, ...uploaded].slice(0, 4);
      setPreviews(newPreviews);
      updateFormImages(newPreviews);
    } catch (err) {
      console.error("Upload error:", err);
      alert("Error subiendo imágenes");
    } finally {
      setUploading(false);
    }
  };

  const handleRemove = (id) => {
    const updated = previews.filter((p) => p.id !== id);
    setPreviews(updated);
    updateFormImages(updated);
  };

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-6 p-4 rounded-lg text-left bg-primary-green">
        <h3 className="text-white text-xl md:text-3xl font-bold">
          Nos interesa conocer tu trabajo para brindarte la mejor atención.
        </h3>
        <p className="text-white text-xl">
          Si tienes redes sociales donde compartas tu trabajo, pega el enlace:
          (opcional)
        </p>

        {/* Input field */}
        <input
          type="text"
          placeholder="www.tusredes.com"
          value={data.url}
          onChange={handleInputChange}
          className="w-full px-3 py-2 rounded text-black text-sm"
        />

        {/* Checkboxes group */}
        {subsections.map((section) => (
          <div key={section.id} className="flex flex-col gap-2">
            {section.type === "checkbox" &&
              section.options.map((option) => (
                <label
                  key={option}
                  className="flex items-center gap-3 text-white text-sm cursor-pointer"
                >
                  <input
                    type="checkbox"
                    checked={!!data[section.id]?.[option]}
                    onChange={(e) =>
                      handleCheckboxChange(section.id, option, e.target.checked)
                    }
                    className="w-4 h-4 rounded border-gray-300 accent-black"
                  />
                  {option}
                </label>
              ))}
          </div>
        ))}

        {/* Image uploader */}
        <div>
          <p className="text-white text-sm mb-2">
            Sube hasta 4 fotos (opcional)
          </p>
          <div className="flex flex-col gap-2">
            <label
              htmlFor="file-upload"
              className={`cursor-pointer inline-block px-4 py-2 rounded-lg font-bold text-sm 
             ${
               uploading || previews.length >= 4
                 ? "bg-gray-400 text-gray-200 cursor-not-allowed"
                 : "bg-white text-primary-green hover:bg-gray-200"
             }`}
            >
              {uploading ? "Subiendo..." : "Seleccionar imágenes"}
            </label>

            <input
              id="file-upload"
              type="file"
              accept="image/*"
              multiple
              onChange={handleFileChange}
              disabled={uploading || previews.length >= 4}
              className="hidden"
            />
          </div>

          {uploading && <p className="text-white text-sm">Subiendo...</p>}

          <div className="grid grid-cols-2 gap-2 mt-2">
            {previews.map((p) => (
              <div key={p.id} className="relative">
                <img
                  src={p.remoteUrl}
                  alt="preview"
                  className="w-full h-32 object-cover rounded-lg"
                />
                <button
                  type="button"
                  onClick={() => handleRemove(p.id)}
                  className="absolute top-1 right-1 bg-black bg-opacity-60 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs"
                >
                  ✕
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>

      <p className="text-white text-xs md:text-xl md:text-left text-center">
        Con esta información podremos brindarte acceso a la plataforma.
      </p>
    </div>
  );
};

export default Step3Form;
